import styled from 'styled-components';

export const StyledFooter = styled.footer`
  height: 40px;
  border-top: 1px solid var(--color-pale-gray);
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0 24px;

  figure {
    &:first-child {
      width: 77px;
      height: 25px;
    }

    > img {
      width: 100%;
      height: 100%;
      object-fit: contain;
    }
  }

  .copylight {
    font-size: 12px;
    color: var(--color-footer-gray);
  }
`;
